// src/pages/GamePreview.js
import React, { useEffect, useState } from "react";
import "./GamePreview.css";
import Card from "../ui/Card";

const FALLBACK_IMG = "/brand/fallback-game.png";
const PLAY_ICON = "/brand/play-icon.svg";

const GAMES = [
  { id: "move-it",  title: "Move-It",   tagline: "Impulse Control" },
  { id: "pingwins", title: "PingWins",  tagline: "Quick Decision-Making" },
  { id: "two-flags",title: "Two-Flags", tagline: "Emotional Regulation" },
  { id: "maxit",    title: "MaxIt",     tagline: "Strategic Thinking" },
  { id: "climbup",  title: "ClimbUp",   tagline: "Goal Commitment" },
  { id: "blocker",  title: "Blocker",   tagline: "Distraction Filtering" },
];

export default function GamePreview() {
  const [soon, setSoon] = useState(null);

  const onCardClick = (g) => setSoon(g);
  const onPlay = (g) => alert(`Launching ${g.title} (stub)`);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setSoon(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="games-wrap nia-page">
      <Card className="nia-hero">
        <div className="nia-header">
          <div>
            <h2>NEUROGRES™ Cognitive Game Set</h2>
            <p>Impulse control, regulation, and focus training engineered to feel effortless.</p>
          </div>
        </div>
      </Card>

      {/* 2 rows x 3 columns on desktop */}
      <div className="games-grid">
        {GAMES.map((g) => (
          <Card key={g.id} className="game-card" style={{ padding: 0 }}>
            <button
              className="thumb"
              aria-label={`About ${g.title}`}
              onClick={() => onCardClick(g)}
              style={{ backgroundImage: `url(${FALLBACK_IMG})` }}
            >
              <img
                className="thumb-img"
                src={FALLBACK_IMG}
                alt={`${g.title} preview`}
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
              <img className="play-icon" src={PLAY_ICON} alt="" aria-hidden="true" />
            </button>

            <div className="card-footer">
              <div>
                <div className="game-title">{g.title}</div>
                <div className="game-tagline">{g.tagline}</div>
              </div>
              <button className="btn btn-primary" onClick={() => onPlay(g)}>Play</button>
            </div>
          </Card>
        ))}
      </div>

      {/* Coming soon modal */}
      {soon && (
        <div className="games-modal-backdrop" onClick={() => setSoon(null)} role="presentation">
          <div
            className="games-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="gs-title"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 id="gs-title" style={{ margin: 0 }}>{soon.title}</h3>
            <p style={{ marginTop: 6, color: "var(--muted)" }}>{soon.tagline}</p>

            <div className="games-modal-body">
              <strong>Coming soon.</strong> We’re polishing the experience so it feels effortless and fun.
            </div>

            <div className="games-modal-actions">
              <button className="btn btn-primary" onClick={() => setSoon(null)}>OK</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
